/* eslint-disable import/no-anonymous-default-export */
import { api } from "./apiServices";

export const loginUser = (user) => api().post("/auth/login",user).then(handleResponse);
export const createKey = (data) => api().post("/auth/create-key",data).then(handleResponse);
export const getAppData = (data) => api().get("/auth/get-app-data").then(handleResponse);
export const getAds = (limit) => api().get("/app/ads?" + `limit=${limit}`).then(handleResponse);

const handleResponse = (response) => {
  let data = response.data;
  if(response.data.code==6){
    localStorage.removeItem("token");
    window.location.href = "/"
  }
  return data;
};
